import type { ThemePalette } from "./types";

export const nord: ThemePalette = {
	id: "nord-dark",
	name: "Nord",
	family: "nord",
	appearance: "dark",

	background: "#2e3440",
	foreground: "#d8dee9",
	card: "#3b4252",
	cardForeground: "#d8dee9",
	popover: "#3b4252",
	popoverForeground: "#d8dee9",

	primary: "#88c0d0",
	primaryForeground: "#2e3440",
	secondary: "#434c5e",
	secondaryForeground: "#d8dee9",
	muted: "#434c5e",
	mutedForeground: "#4c566a",
	accent: "#81a1c1",
	accentForeground: "#2e3440",
	destructive: "#bf616a",
	destructiveForeground: "#eceff4",

	border: "#4c566a",
	input: "#434c5e",
	ring: "#88c0d0",

	success: "#a3be8c",
	warning: "#ebcb8b",
	error: "#bf616a",
	info: "#5e81ac",

	chart1: "#88c0d0",
	chart2: "#bf616a",
	chart3: "#ebcb8b",
	chart4: "#b48ead",
	chart5: "#a3be8c",
};

export const nordLight: ThemePalette = {
	id: "nord-light",
	name: "Nord Light",
	family: "nord",
	appearance: "light",

	background: "#eceff4",
	foreground: "#2e3440",
	card: "#e5e9f0",
	cardForeground: "#2e3440",
	popover: "#e5e9f0",
	popoverForeground: "#2e3440",

	primary: "#5e81ac",
	primaryForeground: "#eceff4",
	secondary: "#d8dee9",
	secondaryForeground: "#2e3440",
	muted: "#d8dee9",
	mutedForeground: "#4c566a",
	accent: "#81a1c1",
	accentForeground: "#eceff4",
	destructive: "#bf616a",
	destructiveForeground: "#eceff4",

	border: "#d8dee9",
	input: "#d8dee9",
	ring: "#5e81ac",

	success: "#a3be8c",
	warning: "#ebcb8b",
	error: "#bf616a",
	info: "#5e81ac",

	chart1: "#88c0d0",
	chart2: "#bf616a",
	chart3: "#ebcb8b",
	chart4: "#b48ead",
	chart5: "#a3be8c",
};
